import { Component, Inject } from '@angular/core';
import { ToolbarControlContext, TOOLBAR_CONTROL_CONTEXT } from '../toolbar-control.tokens';
import { BaseControl } from './base-control';

/**
 * Chrome-only control plugins — things that occupy a slot in the bar without
 * doing anything.
 *
 * A separator is a per-sensor decision (which controls belong together depends
 * on which controls that sensor shows), and the host deliberately knows nothing
 * about grouping. Making it a registered control keeps that decision where every
 * other composition decision already lives: `SENSOR_TOOLBAR_CONFIGS`.
 *
 * `aria-hidden` because this is a painted line, not structure — the grouping it
 * suggests is visual, and every control it separates already announces itself.
 */
@Component({
  selector: 'app-separator-control',
  template: `<span class="tb-sep" aria-hidden="true"></span>`,
})
export class SeparatorControlComponent extends BaseControl {
  constructor(@Inject(TOOLBAR_CONTROL_CONTEXT) public context: ToolbarControlContext) {
    super();
  }
}
